import { Download } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";
import Reveal from "../components/Reveal";
import { LOCATIONS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

/** The marina publishes its winter service list and prices as a brochure image
 *  and PDF. Both are served from our own origin; nothing here is transcribed or
 *  re-priced by us. */
export default function Winterization() {
  return (
    <>
      <Seo
        title="Winterization | West Branch Marina"
        description="Winter services at West Branch Marina: storage, cleaning, winterization and shrink-wrap."
        path="/winterization"
      />

      <PageHero eyebrow="Winterization" title="2025 Winterization & Storage Service" />

      <Section tone="white">
        <Reveal>
          <p data-testid="winterization-intro" className="max-w-3xl text-base leading-relaxed text-slate-700">
            We offer a wide variety of winter services ranging from storage, to cleaning, to
            winterization and shrink-wrap. Please refer to the images below for a full list of services
            and prices, and call us with any questions or to schedule an appointment.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="/site-assets/winterization/2025_WINTER_BROCHURE.pdf"
              download
              data-testid="winterization-brochure-link"
              className="inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3.5 text-sm font-bold text-white transition-all hover:bg-ember-hover hover:-translate-y-0.5"
            >
              <Download className="h-4 w-4" aria-hidden="true" />
              2025 Winter Brochure
            </a>
            <a
              href={WB.phoneHref}
              data-testid="winterization-call-link"
              className="inline-flex items-center gap-2 rounded-full border border-navy/20 px-6 py-3.5 text-sm font-bold text-navy hover:bg-sand-card"
            >
              {WB.phone}
            </a>
          </div>
        </Reveal>

        <Reveal delay={90} className="mt-12">
          <img
            src="/site-assets/winterization/winter-services-prices.png"
            alt="Full list of winter services and prices"
            data-testid="winterization-services-image"
            className="w-full rounded-3xl border border-sand-border"
            loading="lazy"
          />
        </Reveal>
      </Section>
    </>
  );
}
